import firebase from 'firebase';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyBNnFmoh2eDQU0mcYuUSHF5idjODBTHAnQ",
    authDomain: "meal-prep-94e7c.firebaseapp.com",
    databaseURL: "https://meal-prep-94e7c.firebaseio.com",
    projectId: "meal-prep-94e7c",
    storageBucket: "meal-prep-94e7c.appspot.com",
    messagingSenderId: "895735189005",
    appId: "1:895735189005:web:5bebd5a89f8eb137"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);